'use client';
import type { ABSmartlyContext } from '../types/absmartly';
import { getVariantsArray } from './variants';

export function setupForcedVariants(context: ABSmartlyContext, experimentPrefix = 'test_') {
  const params = new URLSearchParams(window?.location?.search);
  if (params.size === 0) {
    return;
  }

  for (const [key, variant] of params.entries()) {
    if (!key.startsWith(experimentPrefix)) {
      continue;
    }
    const newKey = key.replace(experimentPrefix, '');
    const variantsList = getVariantsArray(context, newKey);

    const targetIndex = variantsList.findIndex((vr: string) => vr === variant);
    if (targetIndex !== -1) {
      context.override(newKey, targetIndex);
    }
  }
}
